import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';

import styles from './CustomWidgetCategoryView.css';
import SelectViewContainer from './SelectViewContainer.js';
import CreateView from './CreateView.js';

const SELECTION_VIEW_NAME = 'select';
const CREATION_VIEW_NAME = 'create';

export default class CustomWidgetCategoryView extends React.Component {
  constructor(props) {
    super(props);

    this.addNewWidget = this.addNewWidget.bind(this);
    this.navigateTo = this.navigateTo.bind(this);
    this.navigateToCreation = this.navigateToCreation.bind(this);
    this.navigateToSelection = this.navigateToSelection.bind(this);
    this.selectListItem = this.selectListItem.bind(this);
    this.initCategoryNavigation = this.initCategoryNavigation.bind(this);

    this.state = {
      view: SELECTION_VIEW_NAME,
      selectedListItem: null
    };
  }

  addNewWidget(widget) {
    this.props.addNewWidget(widget);
    this.navigateToSelection();
  }

  navigateTo(view) {
    this.setState({ view });
  }

  navigateToSelection() {
    this.setState({
      view: SELECTION_VIEW_NAME
    });
  }

  navigateToCreation() {
    this.setState({
      view: CREATION_VIEW_NAME
    });
  }

  selectListItem(key) {
    this.setState({
      selectedListItem: key
    });
  }

  initCategoryNavigation() {
    let widgets = this.props.widgets;
    //reorder the widget's list so it matches the navigation order
    widgets = widgets.sort((widget) => {
      switch (widget.subtype) {
        case 'freeform':
          return -1;

        case 'pdf':
          return 0;

        case 'swf':
          return 1;

        case 'iframe':
          return 2;

        default:
          return 3;
      }
    });
    const firstItemKey = widgets.map((widget, widgetIndex) => {
      if(widgetIndex === 0){
        const itemKey = widget.subtype + widget.id;
        return itemKey;
      }
      return undefined;
    });
    let firstCategoryItemDOMNode = ReactDOM.findDOMNode(this).getElementsByTagName('li')[0];
    firstCategoryItemDOMNode = firstCategoryItemDOMNode.getElementsByTagName('div')[0];
    firstCategoryItemDOMNode.focus();
    this.selectListItem(firstItemKey[0]);
  }

  render() {
    const {
      widgets,
      increment,
      decrement,
      deleteCustomWidget,
      editWidget,
      fileUploadUrl,
      widgetIdsOnDashboard,
      handleSuccess,
      focusSearchInput,
    } = this.props;

    let subview;
    if(this.state.view === SELECTION_VIEW_NAME) {
      subview = (
        <SelectViewContainer
          widgets={widgets}
          createCustomWidget={this.navigateToCreation}
          increment={increment}
          decrement={decrement}
          selectListItem={this.selectListItem}
          selectedListItem={this.state.selectedListItem}
          editWidget={editWidget}
          fileUploadUrl={fileUploadUrl}
          deleteCustomWidget={deleteCustomWidget}
          widgetIdsOnDashboard={widgetIdsOnDashboard}
          handleSuccess={handleSuccess}
          focusSearchInput={focusSearchInput}
        />
      );
    } else if(this.state.view === CREATION_VIEW_NAME) {
      subview = (
        <CreateView
          addNewWidget={this.addNewWidget}
          cancelCreation={this.navigateToSelection}
          fileUploadUrl={fileUploadUrl}
        />
      );
    }

    return (
      <div className={styles.wrapper}>
        {subview}
      </div>
    );
  }
}

CustomWidgetCategoryView.propTypes = {
  addNewWidget: PropTypes.func.isRequired,
  decrement: PropTypes.func.isRequired,
  deleteCustomWidget: PropTypes.func.isRequired,
  editWidget: PropTypes.func.isRequired,
  fileUploadUrl: PropTypes.string,
  increment: PropTypes.func.isRequired,
  handleSuccess: PropTypes.func,
  focusSearchInput: PropTypes.func,
  widgets: PropTypes.arrayOf(PropTypes.object).isRequired,
  widgetIdsOnDashboard: PropTypes.arrayOf(PropTypes.string)
};
CustomWidgetCategoryView.defaultProps = {
  handleSuccess: () => undefined,
  focusSearchInput: () => undefined,
};
